module.exports = __webpack_public_path__ + "img/clubicon-console.ef1d595d.png";